import { Model } from '@gameonly/core';

import SimpleReportCover from './pages/SimpleReportCover';
import {
  getGlobalScore,
  getTitleResult,
  PageType,
  PaginatedResult,
} from './utils';

import BackCover from './pages/BackCover';
import CompleteReportCover from './pages/CompleteReportCover';
import { IndicatorPage } from './pages/IndicatorPage';
import ResultFullPage from './pages/ResultFullPage';
import ResultsDetailedPage from './pages/ResultsDetailedPage';
import Summary from './pages/Summary';

export const PdfCompleteReport = ({
  paginatedResults,
  reportDate,
  year,
  model,
}: {
  paginatedResults: PaginatedResult[];
  reportDate: Date;
  year: number | undefined;
  model?: Model;
}) => {
  if (!paginatedResults) return null;
  return (
    <>
      {paginatedResults.map(
        (paginatedResult: PaginatedResult, index: number) => {
          switch (paginatedResult.pageType) {
            case PageType.COVER_COMPLETE:
              return (
                <CompleteReportCover
                  reportDate={reportDate}
                  year={year}
                  projectName={paginatedResult.data?.projectName}
                />
              );
            case PageType.COVER_SIMPLE:
              return (
                <SimpleReportCover
                  reportDate={reportDate}
                  year={year}
                  projectName={paginatedResult.data?.projectName}
                />
              );
            case PageType.SUMMARY:
              return (
                <Summary
                  paginatedResults={paginatedResults}
                  year={year}
                  model={model}
                />
              );
            case PageType.BACK_COVER:
              return <BackCover />;
            case PageType.MAIN_INDICATOR:
              const titleResult = getTitleResult(paginatedResult.results);
              const scoreResult = getGlobalScore(paginatedResult.results);
              if (!titleResult || !scoreResult) return null;
              return (
                <IndicatorPage
                  title={titleResult}
                  score={scoreResult}
                  year={year}
                  pageNumber={paginatedResult.pageNumber}
                  modelName={model?.name || ''}
                />
              );
            case PageType.RESULT_FULL_PAGE:
              return (
                <ResultFullPage
                  key={index}
                  paginatedResult={paginatedResult}
                  model={model}
                  year={year}
                />
              );
            case PageType.RESULTS_DETAILED:
              return (
                <ResultsDetailedPage
                  key={index}
                  paginatedResult={paginatedResult}
                  model={model}
                  year={year}
                />
              );
            default:
              return null;
          }
        },
      )}
    </>
  );
};
